import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import DocumentRenderer from "./DocumentRenderer";
import GenericModal from "./GenericModal";
import ModalAdminreferralstatus from "./ModalAdminreferralstatus";
import ModalAdminSuccess from "./ModalAdminsuccess";
import Navbar from "./Navbar";
import { updateQueriesItems } from "./redux/slices/QueriesThunks";
import {
  fetchReferralById,
  fetchReferralHistoryItemsById,
  updateReferralsItems,
} from "./redux/slices/ReferralsThunks";
import ToolTip from "./prtnr/ui/ToolTip";
import { UrgentIcon } from "./assets";

export default function Adminreferralsthree() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [referralData, setReferralData] = useState(null);
  const [editReferralData, setEditReferralData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [active, setActive] = useState("Member");
  const [history, setHistory] = useState([]);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [referralLoading, setreferralLoading] = useState(false);

  const formattedDate = (date) => {
    const newDate = new Date(date);
    const formatted = newDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return formatted;
  };

  const openModal = (type) => {
    setActive(type);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    getHistory();
    setIsModalOpen(false);
  };

  const formatDate2 = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);

    return date.toISOString().split("T")[0]; // "2025-06-18"
  };

  const handleUpdate = async () => {
    const data = {
      _id: editReferralData?._id,
      notes: editReferralData?.notes,
      expected_close_date: editReferralData?.expected_close_date,
      updated_at: Date.now(),
    };
    try {
      await dispatch(updateReferralsItems(data));
      setReferralData(editReferralData);
      setIsSuccessModalOpen(true);
    } catch (e) {
      console.log(e, "error");
    }
  };
  const handleResolve = () => {
    if (referralData?.dispute?.dispute_status === "Open") {
      const updatedData = {
        ...referralData,
        dispute: {
          ...referralData.dispute,
          dispute_status: "Resolved",
        },
      };

      dispatch(updateQueriesItems(updatedData.dispute));
      setReferralData(updatedData);
    }
  };

  const fetchReferralData = async () => {
    try {
      setLoading(true);
      const result = await dispatch(fetchReferralById(id));

      if (result.payload?.message === "Record not found") {
        navigate("/adminreferralsone");
        return;
      }

      if (result.payload) {
        setReferralData(result.payload);
        setEditReferralData(result.payload);
      }
    } catch (error) {
      console.error("Error fetching referral:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const getHistory = async () => {
    const res = await dispatch(fetchReferralHistoryItemsById(id));
    if (res.payload.length > 0) {
      setHistory(res.payload);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (id) {
      fetchReferralData();
      getHistory();
    }
  }, [id]);

  return (
    <RootWrapperAdminreferralsthree>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          {loading ? (
            "Loading..."
          ) : (
            <Right>
              <Frame1545>
                <DashboardHeader>
                  <Frame1462>
                    <LinkButton>
                      <BackContainer
                        onClick={() => {
                          navigate("/adminreferralsone");
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3334 8H2.66675"
                            stroke="#3B5A6F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66675 12L2.66675 8L6.66675 4"
                            stroke="#6162C5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <BackText>Back</BackText>
                      </BackContainer>
                    </LinkButton>
                    <WelcomeJames>
                      Referral Details # [R{referralData?._id.slice(-7)}]
                    </WelcomeJames>
                  </Frame1462>
                </DashboardHeader>
              </Frame1545>
              <Frame1557>
                <Frame1552>
                  <ReferralStatusMember>
                    Referral Status: Member
                  </ReferralStatusMember>
                  <Frame1571>
                    <Notifiaton1>
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="32"
                          height="32"
                          rx="16"
                          fill="#F4BA34"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M10.75 9.40625C10.75 9.05078 11.0234 8.75 11.4062 8.75H20.5938C20.9492 8.75 21.25 9.05078 21.25 9.40625C21.25 9.78906 20.9492 10.0625 20.5938 10.0625H20.375V10.582C20.375 11.7031 19.9375 12.7422 19.1445 13.5352L16.9023 15.75L19.1445 17.9922C19.9375 18.7578 20.375 19.8242 20.375 20.918V21.4375H20.5938C20.9492 21.4375 21.25 21.7383 21.25 22.0938C21.25 22.4766 20.9492 22.75 20.5938 22.75H11.4062C11.0234 22.75 10.75 22.4766 10.75 22.0938C10.75 21.7383 11.0234 21.4375 11.4062 21.4375H11.625V20.918C11.625 19.8242 12.0625 18.7578 12.8281 17.9922L15.0703 15.75L12.8281 13.5352C12.0625 12.7422 11.625 11.7031 11.625 10.582V10.0625H11.4062C11.0234 10.0625 10.75 9.78906 10.75 9.40625ZM13.7578 18.9219C13.6484 19.0312 13.5664 19.1406 13.457 19.25H18.5156C18.4336 19.1406 18.3242 19.0312 18.2148 18.9219L16 16.6797L13.7578 18.9219ZM18.5156 12.25C18.8711 11.7852 19.0625 11.1836 19.0625 10.582V10.0625H12.9375V10.582C12.9375 11.2109 13.1289 11.7852 13.457 12.25H18.5156Z"
                          fill="#F4BA34"
                        />
                      </svg>
                      <Frame1435>
                        <Frame1545_0001>
                          <_2Apr2025>
                            {formattedDate(referralData?.created_at)}
                          </_2Apr2025>
                        </Frame1545_0001>
                        <Frame1437>
                          <Frame1547_0001>
                            <Tracking
                              status={referralData?.referral_member_status}
                            >
                              {referralData?.referral_member_status}
                            </Tracking>
                          </Frame1547_0001>
                        </Frame1437>
                      </Frame1435>
                    </Notifiaton1>
                    <LinkButton>
                      <BackContainer
                        onClick={() => {
                          openModal("Member");
                        }}
                      >
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z"
                            stroke="#3B5A6F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z"
                            stroke="#6162C5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <ActiveText>Change status</ActiveText>
                      </BackContainer>
                    </LinkButton>
                  </Frame1571>
                  <div>
                    <ReferralRejectionReason>
                      Referral Rejection Reason:{" "}
                    </ReferralRejectionReason>
                    <Tracking2> {referralData?.reject_reason}</Tracking2>
                  </div>
                </Frame1552>
                <Frame1552>
                  <ReferralStatusVendor>
                    Referral Status: Vendor
                  </ReferralStatusVendor>
                  <Frame1571>
                    <Notifiaton1>
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                          fill="#5954DE"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M18.1875 12.4897C18.1875 11.7241 17.75 11.0132 17.0938 10.603C16.4102 10.2202 15.5625 10.2202 14.9062 10.603C14.2227 11.0132 13.8125 11.7241 13.8125 12.4897C13.8125 13.2827 14.2227 13.9937 14.9062 14.4038C15.5625 14.7866 16.4102 14.7866 17.0938 14.4038C17.75 13.9937 18.1875 13.2827 18.1875 12.4897ZM12.5 12.4897C12.5 11.2593 13.1562 10.1108 14.25 9.48193C15.3164 8.85303 16.6562 8.85303 17.75 9.48193C18.8164 10.1108 19.5 11.2593 19.5 12.4897C19.5 13.7476 18.8164 14.896 17.75 15.5249C16.6562 16.1538 15.3164 16.1538 14.25 15.5249C13.1562 14.896 12.5 13.7476 12.5 12.4897ZM11.2148 21.6772H20.7578C20.5117 19.9546 19.0352 18.6147 17.2305 18.6147H14.7422C12.9375 18.6147 11.4609 19.9546 11.2148 21.6772ZM9.875 22.1968C9.875 19.4897 12.0352 17.3022 14.7422 17.3022H17.2305C19.9375 17.3022 22.125 19.4897 22.125 22.1968C22.125 22.6343 21.7422 22.9897 21.3047 22.9897H10.668C10.2305 22.9897 9.875 22.6343 9.875 22.1968Z"
                          fill="#5954DE"
                        />
                      </svg>
                      <Frame1435>
                        <Frame1545_0001>
                          <_1Apr2025>
                            {formattedDate(referralData?.created_at)}
                          </_1Apr2025>
                        </Frame1545_0001>
                        <Frame1546>
                          <ReferralSubmitted>
                            {referralData?.referral_status}
                          </ReferralSubmitted>
                        </Frame1546>
                      </Frame1435>
                    </Notifiaton1>
                    <LinkButton_0002>
                      <BackContainer
                        onClick={() => {
                          openModal("Vendor");
                        }}
                      >
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z"
                            stroke="#3B5A6F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z"
                            stroke="#6162C5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <ActiveText>Change status</ActiveText>
                      </BackContainer>
                    </LinkButton_0002>
                  </Frame1571>
                </Frame1552>
              </Frame1557>
              {referralData?.dispute == null ? (
                <></>
              ) : (
                <Frame1557New>
                  <Frame1566>
                    <Frame1565>
                      <Frame1564>
                        <Dispute345678>
                          Dispute #{referralData._id.slice(-7)}
                        </Dispute345678>
                        <Created23March2025>
                          Created:{" "}
                          {formattedDate(referralData.dispute?.date_raised)}
                        </Created23March2025>
                      </Frame1564>
                    </Frame1565>

                    {referralData?.dispute?.dispute_status == "Open" ? (
                      <AIMEButton
                        size="small"
                        onClick={() => {
                          handleResolve();
                        }}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                          alignItems: "center",
                          flex: "none",
                          gap: "10px",
                          borderRadius: "48px",
                          background: "rgb(118, 192, 101)",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          boxSizing: "border-box",
                          padding: "16px 32px",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            textOverflow: "ellipsis",
                            fontSize: "16px",
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: "600",
                            lineHeight: "110%",
                            textAlign: "left",
                          }}
                        >
                          Resolve
                        </span>
                      </AIMEButton>
                    ) : (
                      <MemberStatusTags>
                        <TrackingText>Resolved</TrackingText>
                      </MemberStatusTags>
                    )}
                  </Frame1566>
                  <DisputeMessage>
                    <Frame1568>
                      <Frame1566>
                        <Frame1566_0001>
                          <Frame1564_0001
                            src={referralData?.member_id?.profile_picture}
                            alt="icon"
                          />
                          <Frame1565_0001>
                            <JohnnyDepp>
                              {referralData?.member_id &&
                                referralData?.member_id?.first_name +
                                  " " +
                                  referralData?.member_id?.last_name}
                            </JohnnyDepp>
                            <Member>Member</Member>
                          </Frame1565_0001>
                        </Frame1566_0001>
                        <_23March20251015Am>
                          {formattedDate(referralData.dispute?.date_raised)}
                        </_23March20251015Am>
                      </Frame1566>
                      <ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail>
                        {referralData.dispute?.explanation}
                      </ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail>

                      <DocumentRenderer
                        fileUrl={referralData.dispute?.supporting_document}
                      ></DocumentRenderer>
                    </Frame1568>
                  </DisputeMessage>
                </Frame1557New>
              )}
              <Frame1558>
                <Frame1581>
                  <MemberProfile>Member Profile</MemberProfile>
                  <LinkButton>
                    <BackContainer
                      onClick={() => {
                        navigate(
                          `/adminmembersone/${referralData.member_id._id}`
                        );
                      }}
                    >
                      <ActiveText>View member profile</ActiveText>
                    </BackContainer>
                  </LinkButton>
                </Frame1581>
                <Frame1485>
                  <Frame1538>
                    <ContactPerson>Contact Person</ContactPerson>
                    <JohnnyDepp>
                      {referralData?.member_id &&
                        referralData?.member_id?.first_name +
                          " " +
                          referralData?.member_id?.last_name}
                    </JohnnyDepp>
                  </Frame1538>
                  <Frame1539>
                    <ContactNumber>Contact Number</ContactNumber>
                    <_441234567789>
                      {referralData?.member_id?.phone_number}
                    </_441234567789>
                  </Frame1539>
                  <Frame1540>
                    <EmailAddress>Email address</EmailAddress>
                    <JamesdoeGmailCom>
                      {referralData?.member_id?.email_address
                        ? referralData?.member_id?.email_address.length > 18
                          ? referralData?.member_id?.email_address.slice(
                              0,
                              18
                            ) + "..."
                          : referralData?.member_id?.email_address
                        : ""}
                    </JamesdoeGmailCom>
                  </Frame1540>
                  <Frame1541>
                    <SubmittedOn>Submitted on</SubmittedOn>
                    <_1Apr20251010Am>
                      {formattedDate(referralData?.created_at)}
                    </_1Apr20251010Am>
                  </Frame1541>
                </Frame1485>
              </Frame1558>
              <Frame1485_0001>
                <Frame1557>
                  <Frame1468>
                    <Frame1484>
                      <ReferralsDetails>Referral Details</ReferralsDetails>
                      {/* <LinkButton>
                      
          			<BackContainer onClick={() => {  }}>
						<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M3.03881 11.2656C3.13699 11.0103 3.18609 10.8826 3.27029 10.8242C3.34388 10.7731 3.43493 10.7538 3.52293 10.7706C3.62362 10.7898 3.72032 10.8865 3.91372 11.0799L5.41978 12.586C5.61318 12.7794 5.70988 12.8761 5.72911 12.9767C5.74591 13.0647 5.72659 13.1558 5.67549 13.2294C5.61703 13.3136 5.48939 13.3627 5.23411 13.4609L1.66675 14.8329L3.03881 11.2656Z" stroke="#3B5A6F" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M3.08964 11.1334C3.18065 10.8967 3.22615 10.7784 3.28557 10.6677C3.33835 10.5694 3.39926 10.4757 3.46768 10.3875C3.5447 10.2883 3.63433 10.1986 3.8136 10.0194L11.3334 2.49955C12.0698 1.76317 13.2637 1.76317 14.0001 2.49955C14.7365 3.23593 14.7365 4.42984 14.0001 5.16622L6.48027 12.686C6.301 12.8653 6.21136 12.9549 6.11211 13.032C6.02395 13.1004 5.93022 13.1613 5.83189 13.2141C5.7212 13.2735 5.60289 13.319 5.36626 13.41L1.66675 14.8329L3.08964 11.1334Z" stroke="#6162C5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<ActiveText>
							Edit details
						</ActiveText>
					</BackContainer>
        
                    </LinkButton> */}
                    </Frame1484>
                    <Frame1476>
                      <CompanyWebsite>Company Website</CompanyWebsite>
                      <WwwGreenleafcafeCo>
                        {referralData?.company_website_url}
                      </WwwGreenleafcafeCo>
                    </Frame1476>
                    <Frame1473>
                      <Frame1470>
                        <Frame1476>
                          <Sector>Sector</Sector>
                          <TechnologySoftwareSaaS>
                            {referralData?.industry_sector}
                          </TechnologySoftwareSaaS>
                        </Frame1476>
                      </Frame1470>
                      <Frame1470>
                        <Frame1476>
                          <Location>Primary Location</Location>
                          <LondonUk>{referralData?.location}</LondonUk>
                        </Frame1476>
                      </Frame1470>
                    </Frame1473>
                    <Frame1476>
                      <DoesYourFriendHaveABudgetToWorkTo>
                        Does your friend have a budget to work to ?
                      </DoesYourFriendHaveABudgetToWorkTo>
                      <Unknown>{referralData?.has_budget}</Unknown>
                    </Frame1476>
                    <Frame1473>
                      <Frame1470>
                        <Frame1476>
                          <IsYouFriendADecisionMaker>
                            Is you friend a decision maker
                          </IsYouFriendADecisionMaker>
                          <Yes>
                            {referralData?.is_decision_maker === true
                              ? "Yes"
                              : referralData?.is_decision_maker === false
                              ? "No"
                              : null}
                          </Yes>
                        </Frame1476>
                      </Frame1470>

                      <Frame1470>
                      {referralData?.is_urgent && (
                        <Frame1476>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <IsYouFriendADecisionMaker>
                              Priority
                            </IsYouFriendADecisionMaker>
                            <ToolTip
                              message="Urgent: time-sensitive referral. Quick response requested."
                              icon={UrgentIcon}
                            />
                          </div>
                          <Yes>{referralData?.is_urgent ? "Urgent" : "No"}</Yes>
                        </Frame1476>
                      )}
                      </Frame1470>
                    </Frame1473>
                    <Frame1476>
                      <DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                        Does your friend have an urgent problem or need to
                        address?
                      </DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                      <SelectedOption>
                        {referralData?.urgent_problem === true
                          ? "Yes"
                          : referralData?.urgent_problem === false
                          ? "No"
                          : null}
                      </SelectedOption>
                    </Frame1476>
                    <Frame1476>
                      <InWhatTimeframeWillTheyNeedASolution>
                        In what timeframe will they need a solution?
                      </InWhatTimeframeWillTheyNeedASolution>
                      <SelectedOption>{referralData?.timeframe}</SelectedOption>
                    </Frame1476>
                    <Frame1483_0001>
                      <Frame1483_0002>
                        <PleaseShareAnyRelevantContextOfYourReferral>
                          Please share any relevant context of your referral
                        </PleaseShareAnyRelevantContextOfYourReferral>
                      </Frame1483_0002>
                      <Frame1472>
                        <AddSomeNotesHere>
                          {referralData?.relevant_context_of_referral}
                        </AddSomeNotesHere>
                      </Frame1472>
                    </Frame1483_0001>
                  </Frame1468>
                  <Frame1580>
                    <ActivityNotification>
                      <Frame1583>
                        <Frame1435_0002>
                          <Reward>Reward</Reward>
                          <_200>£{referralData?.reward}</_200>
                        </Frame1435_0002>
                        <Frame1434>
                          <AmountAtTheTimeOfSubmission>
                            Reward amount when you submitted this referral
                          </AmountAtTheTimeOfSubmission>
                        </Frame1434>
                      </Frame1583>
                      <Frame1476>
                        <SubmittedOn_0001>Submitted on:</SubmittedOn_0001>
                        <_19January2025181025>
                          {formattedDate(referralData?.created_at)}
                        </_19January2025181025>
                      </Frame1476>
                    </ActivityNotification>
                    <Right_0001>
                      <InternalNotes>
                        <PRTNR.Input
                          label="Expected Close Date"
                          type="date"
                          min={new Date().toISOString().split("T")[0]}
                          value={formatDate2(
                            editReferralData?.expected_close_date
                          )}
                          onChange={(e) => {
                            setEditReferralData({
                              ...editReferralData,
                              expected_close_date: e.target.value,
                            });
                          }}
                        />
                        <PRTNR.TextArea
                          label={"Paartner Admin Notes"}
                          value={editReferralData?.notes}
                          rows={6}
                          onChange={(e) => {
                            setEditReferralData({
                              ...editReferralData,
                              notes: e.target.value,
                            });
                          }}
                        />
                        <ButtonContainer>
                          <PRTNR.Button
                            onClick={() => {
                              handleUpdate();
                            }}
                          >
                            Save Changes
                          </PRTNR.Button>
                        </ButtonContainer>
                      </InternalNotes>
                    </Right_0001>
                  </Frame1580>
                </Frame1557>
                <Frame1471_0001>
                  <Frame1484_0001>
                    <Frame1484_0002>
                      <ReferralsDetails_0001>
                        Vendor Profile
                      </ReferralsDetails_0001>
                    </Frame1484_0002>
                  </Frame1484_0001>
                  <Frame1485_0002>
                    <Frame1538_0001>
                      <SubmittedToVendor>Submitted to Vendor</SubmittedToVendor>
                      <Nesti>{referralData?.vendor_id?.company_name}</Nesti>
                    </Frame1538_0001>
                    <Frame1539_0001>
                      <SubmittedOn>Submitted on</SubmittedOn>
                      <Frame1551>
                        <_1Apr2025_0001>
                          {formattedDate(referralData?.created_at)}
                        </_1Apr2025_0001>
                      </Frame1551>
                    </Frame1539_0001>
                    <LinkButton>
                      <BackContainer
                        onClick={() => {
                          navigate(
                            `/adminvendorsone/${referralData.vendor_id._id}`
                          );
                        }}
                      >
                        <ActiveText>View vendor profile</ActiveText>
                      </BackContainer>
                    </LinkButton>
                  </Frame1485_0002>
                </Frame1471_0001>
                <ActivityNotification_0001>
                  <Frame1433_0002>
                    <History>History</History>
                  </Frame1433_0002>
                  {history.length > 0 &&
                    [...history].reverse().map((val, idx) => (
                      <>
                        <PRTNR.AccountHistory
                          status={val.action}
                          date={val.updated_at}
                          changes={val.changes}
                        />
                        {idx < history.length - 1 && <Seperator />}
                      </>
                    ))}
                </ActivityNotification_0001>
              </Frame1485_0001>
            </Right>
          )}
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>
      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminreferralstatus
          isOpen={isModalOpen}
          onClose={closeModal}
          data={referralData}
          setData={setReferralData}
          oldData={editReferralData}
          setOldData={setEditReferralData}
          type={active}
        />
      </GenericModal>
      <GenericModal
        isOpen={isSuccessModalOpen}
        onClose={() => {
          setIsSuccessModalOpen(false);
        }}
      >
        <ModalAdminSuccess
          isOpen={isSuccessModalOpen}
          onClose={() => {
            setIsSuccessModalOpen(false);
          }}
        />
      </GenericModal>
    </RootWrapperAdminreferralsthree>
  );
}

const RootWrapperAdminreferralsthree = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const Frame1545 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-end;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  width: 662px;
  box-sizing: border-box;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 662px;
  box-sizing: border-box;
`;

const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
`;

const Frame1557 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1557New = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  background-color: white;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(225, 228, 233, 1);
`;

const Frame1552 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 9px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  width: 427px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
`;

const ReferralStatusMember = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 280px;
  min-height: 29px;
`;

const Frame1571 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Notifiaton1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 235px;
  box-sizing: border-box;
  padding: 8px;
`;

const Frame1435 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 179px;
  box-sizing: border-box;
`;

const Frame1545_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Frame1547_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 179px;
  box-sizing: border-box;
`;

const Tracking = styled.span`
  color: ${({ status }) =>
    status === "Tracking"
      ? "rgb(244, 186, 52)"
      : status === "Successful"
      ? "green"
      : status === "Unsuccessful"
      ? "red"
      : status === "Admin Rejected"
      ? "red"
      : "black"};

  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 181px;
  flex: 1;
`;

const Tracking2 = styled.span`
  color: rgba(255, 9, 9, 1);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 181px;
  flex: 1;
`;
const ReferralRejectionReason = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 181px;
  flex: 1;
`;

const ReferralStatusVendor = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 280px;
  min-height: 29px;
`;

const _1Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Frame1546 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralSubmitted = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LinkButton_0002 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame1558 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 9px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1581 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 9px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const MemberProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 663px;
  flex: 1;
`;

const Frame1485 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1538 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 133px;
  box-sizing: border-box;
`;

const ContactPerson = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JohnnyDepp = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1539 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-sizing: border-box;
`;

const ContactNumber = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const _441234567789 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1540 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 205px;
  box-sizing: border-box;
`;

const EmailAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JamesdoeGmailCom = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1541 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 156px;
  box-sizing: border-box;
`;

const SubmittedOn = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const _1Apr20251010Am = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1485_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 557px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Frame1484 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralsDetails = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 376px;
  min-height: 29px;
  flex: 1;
`;

const Frame1476 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const CompanyWebsite = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const WwwGreenleafcafeCo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1473 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 255px;
  box-sizing: border-box;
`;

const Sector = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TechnologySoftwareSaaS = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Location = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LondonUk = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveABudgetToWorkTo = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Unknown = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const IsYouFriendADecisionMaker = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Yes = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveAnUrgentProblemOrNeedToAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const SelectedOption = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const InWhatTimeframeWillTheyNeedASolution = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1483_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1483_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const PleaseShareAnyRelevantContextOfYourReferral = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 509px;
  flex: 1;
`;

const Frame1472 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  min-height: 186px;
  background: rgb(243, 244, 251);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const AddSomeNotesHere = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 299px;
`;

const Frame1580 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 297px;
  box-sizing: border-box;
`;

const ActivityNotification = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border-radius: 16px;
  align-self: stretch;
  background: linear-gradient(
    -90deg,
    rgba(18, 124, 78, 0.1),
    rgba(18, 124, 78, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1583 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1435_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Reward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 180px;
  flex: 1;
`;

const _200 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 49px;
  min-height: 20px;
`;

const Frame1434 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AmountAtTheTimeOfSubmission = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 10px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  width: 249px;
  flex: 1;
`;

const SubmittedOn_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _19January2025181025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Right_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 294px;
  box-sizing: border-box;
`;

const PrtnrInput = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Field = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 238px;
  flex: 1;
`;

const IconCaretdown = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  flex: none;
  gap: 8px;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
`;

const CaretDown = styled.div`
  width: 9px;
  height: 5px;
  background: url(https://s3-alpha-sig.figma.com/img/46bf/ca2f/25eedd208bc5c58011128405095de699?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=n3U0PVkcOJ6DdzqUTV7ItxiHygfetSg1aGLDpXq86PK8ykMj09vPlnYeuON2Ls1D0IyyZGZZ5lZW7Fi8niQwxF~i454XB4XoQKcBnLZCO0ggUj9nNQ8ZmPgD8478rSgXLJy8Brmui6wbhDhxGTgIxrOKOFPLtJEj6P25HFGa0bJLRRLvz2aCNNl~RovLRYw5WZ6HHYeke6KeG07hhzrTMCWqxEQwHFkrsRswzOCddYjzKhklNj6sU3ALPAHPQebp73Z~0bm360XPEBaIVkWGI1Xh2ph9~Zg8ejcKikcf2jk4sWAWtyFwGqroChU2a7X1HPRl33qWH70Ig4VFfKnxUg__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const InternalNotes = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  width: 246px;
  box-sizing: border-box;
`;

const InternalNotes_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 248px;
  min-height: 20px;
  flex: 1;
`;

const PrtnrTextarea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Field_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder_0001 = styled.span`
  color: rgb(179, 182, 195);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 215px;
  flex: 1;
`;

const Frame1471_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1484_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1484_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 830px;
  box-sizing: border-box;
`;

const ReferralsDetails_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 832px;
  min-height: 29px;
  flex: 1;
`;

const Frame1485_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Frame1538_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 300px;
  box-sizing: border-box;
`;

const SubmittedToVendor = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1539_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 300px;
  box-sizing: border-box;
`;

const Frame1551 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _1Apr2025_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _1010Am_0002 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const ActivityNotification_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const History = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 830px;
  min-height: 29px;
  flex: 1;
`;

const ActivitesList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 0px 16px;
  flex-shrink: 0;
`;

const Frame1435_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 790px;
  box-sizing: border-box;
`;

const Frame1519 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 719px;
  box-sizing: border-box;
`;

const StatusChangedTo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const ProposalSent = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 743px;
  flex: 1;
`;

const Notifiaton1_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  flex-shrink: 0;
`;

const Frame1435_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 774px;
  box-sizing: border-box;
`;

const Frame1547_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1547_0003 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 774px;
  box-sizing: border-box;
`;

const Tracking_0001 = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 776px;
  flex: 1;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const BackText = styled.span`
  color: #64748b;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const ActiveText = styled.span`
  color: #6162c5;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const Frame1566 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1565 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 14px;
  box-sizing: border-box;
`;

const Frame1564 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 1px;
  width: 161px;
  box-sizing: border-box;
`;

const Dispute345678 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
  width: 350px;
`;

const Created23March2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const DisputeMessage = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border: solid 1px rgb(225, 228, 234);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1568 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1566_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  box-sizing: border-box;
`;

const Frame1564_0001 = styled.img`
  width: 39px;
  height: 39px;
  object-fit: cover;
`;

const Frame1565_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const Member = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _23March20251015Am = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 147px;
`;

const ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 64px;
  align-self: stretch;
  flex-shrink: 0;
`;

const MemberStatusTags = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 4px;
  width: 96px;
  background: linear-gradient(
    -90deg,
    rgba(18, 124, 78, 0.1),
    rgba(18, 124, 78, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 4px 8px;
`;

const TrackingText = styled.span`
  color: rgb(18, 124, 78);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Seperator = styled.div`
  height: 1px;
  background-color: rgba(136, 136, 136, 0.1);
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`;
